// Driver-only screens live here as they are extracted from app/dashboard/home.tsx.

export { DriverHomeScreen } from './DriverHomeScreen';
export type { DriverHomeScreenProps } from './DriverHomeScreen';
